/**
 * Agence'O - scrollbar
 * @author Axel Baron (Agence'O)
 * @created 19/06/2019
 */

(function ($) {

  $('.js-scroll-bar').each((i, item) => {
    const scrollBar = new SimpleBar(item, {
      autoHide: false
    });
  });

}(jQuery));
